function RecordUrl({ url }) {
    try {
        // Function to create a safe YouTube embed URL if it's a YouTube link
        const getYouTubeEmbedUrl = (youtubeUrl) => {
            try {
                // Extract video ID from various YouTube URL formats
                let videoId = null;
                
                // Regular YouTube watch URL: https://www.youtube.com/watch?v=VIDEO_ID
                const watchMatch = youtubeUrl.match(/youtube\.com\/watch\?v=([^&]+)/);
                if (watchMatch) {
                    videoId = watchMatch[1];
                }
                
                // Shortened youtu.be URL: https://youtu.be/VIDEO_ID
                const shortMatch = youtubeUrl.match(/youtu\.be\/([^?&]+)/);
                if (shortMatch) {
                    videoId = shortMatch[1];
                }
                
                // Embed URL: https://www.youtube.com/embed/VIDEO_ID
                const embedMatch = youtubeUrl.match(/youtube\.com\/embed\/([^?&]+)/);
                if (embedMatch) {
                    videoId = embedMatch[1];
                }
                
                if (videoId) {
                    // Use YouTube's privacy-enhanced mode to avoid COOP restrictions
                    return `https://www.youtube-nocookie.com/embed/${videoId}`;
                }
                
                return null;
            } catch (error) {
                console.error('Error parsing YouTube URL:', error);
                return null;
            }
        };
        
        // Check if it's a YouTube URL
        const isYouTubeUrl = url && (url.includes('youtube.com') || url.includes('youtu.be'));
        const embedUrl = isYouTubeUrl ? getYouTubeEmbedUrl(url) : null;
        
        return (
            <div className="mb-4" data-name="record-url-container">
                <h4 className="text-sm font-medium text-gray-700 mb-1">來源網址：</h4>
                <div className="flex flex-col" data-name="url-content">
                    {/* Display the original URL without modification */}
                    <div className="text-blue-600 break-all mb-2" data-name="original-url">
                        {url}
                    </div>
                    
                    {isYouTubeUrl && embedUrl && (
                        <div className="mt-3 bg-gray-50 p-2 rounded-lg border border-gray-200" data-name="youtube-embed-container">
                            <div className="relative pt-[56.25%] w-full">
                                <iframe
                                    className="absolute inset-0 w-full h-full rounded"
                                    src={embedUrl}
                                    title="YouTube video player"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                    data-name="youtube-embed"
                                ></iframe>
                            </div>
                            <div className="mt-2 text-xs text-gray-500 text-center">
                                如果影片無法顯示，請使用上方原始連結
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    } catch (error) {
        console.error('RecordUrl component error:', error);
        reportError(error);
        return null;
    }
}

export default RecordUrl;